import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { ApiService } from "../shared/utilities/api.service";
import { MembershipListConfig } from "../../models";
import { MembershipListResult } from "../../interfaces";

@Injectable()
export class MemberService {
  constructor(private apiService: ApiService) {}

  public findManyMembers(
    communityName: string,
    config: MembershipListConfig
  ): Observable<MembershipListResult> {
    let params = {};

    Object.keys(config).forEach((key) => {
      params[key] = config[key];
    });

    // GET /api/communities/:community/members
    const getURL = `/communities/${communityName}/members`;
    var finalParams = new HttpParams({ fromObject: params });

    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
